import React, { useEffect, useState, useCallback } from 'react';
import './Navbar.css';

const NAV_ITEMS = [
    { id: 'services', label: 'Услуги' },
    { id: 'product', label: 'Продукт' },
    { id: 'tech', label: 'Технологии' },
];

function BrandMark({ className = '' }) {
    return (
        <span className={`brand-mark ${className}`} aria-hidden="true">
            <svg viewBox="0 0 40 40" fill="none">
                <defs>
                    <linearGradient id="brandGrad" x1="6" y1="4" x2="34" y2="36" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#60A5FA" />
                        <stop offset="0.55" stopColor="#818CF8" />
                        <stop offset="1" stopColor="#C084FC" />
                    </linearGradient>
                </defs>
                <rect x="1.5" y="1.5" width="37" height="37" rx="11" stroke="url(#brandGrad)" strokeWidth="1.4" opacity="0.55" />
                <path
                    d="M20 8.5L29.5 28H24.6L22.7 23.4H17.3L15.4 28H10.5L20 8.5Z"
                    stroke="url(#brandGrad)"
                    strokeWidth="1.6"
                    strokeLinejoin="round"
                    fill="none"
                />
                <circle className="brand-mark-core" cx="20" cy="16.2" r="2.2" fill="url(#brandGrad)" />
                <circle className="brand-mark-orbit" cx="14.2" cy="26.8" r="1.35" fill="#60A5FA" />
                <circle className="brand-mark-orbit brand-mark-orbit--delay" cx="25.8" cy="26.8" r="1.35" fill="#C084FC" />
                <path d="M20 18.4V23.2" stroke="url(#brandGrad)" strokeWidth="1.2" strokeLinecap="round" opacity="0.7" />
            </svg>
        </span>
    );
}

function BrandWord({ light = false }) {
    return (
        <span className={`brand-word ${light ? 'brand-word--light' : ''}`}>
            <span className="brand-word-ai">AI</span>
            <span className="brand-word-coll">Coll</span>
        </span>
    );
}

function Navbar() {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const handleNavClick = useCallback((e, targetId) => {
        e.preventDefault();
        const target = document.querySelector(targetId);
        if (target) {
            target.scrollIntoView({ behavior: 'smooth' });
        }
    }, []);

    return (
        <nav className={`site-nav ${scrolled ? 'is-scrolled' : ''}`}>
            <div className="site-nav-inner">
                <span className="site-nav-sheen" aria-hidden="true" />
                <span className="site-nav-spec" aria-hidden="true" />

                <a href="/" className="nav-brand" aria-label="AIColl — на главную">
                    <BrandMark />
                    <span className="nav-brand-text">
                        <BrandWord />
                        <span className="nav-brand-tag">studio</span>
                    </span>
                </a>

                <ul className="nav-links">
                    {NAV_ITEMS.map((item) => (
                        <li key={item.id}>
                            <a
                                href={`#${item.id}`}
                                className="nav-link"
                                onClick={(e) => handleNavClick(e, `#${item.id}`)}
                            >
                                {item.label}
                            </a>
                        </li>
                    ))}
                    <li>
                        <a href="/app.html" className="nav-cta">
                            <span>Войти</span>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                <path d="M5 12h14M12 5l7 7-7 7" />
                            </svg>
                        </a>
                    </li>
                </ul>
            </div>
        </nav>
    );
}

export { BrandMark, BrandWord };
export default Navbar;
